module.exports = __webpack_public_path__ + "assets/TrBySideAndCentroid.647752b0da3e3c3cb0276ead8ac78238.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/TrBySideAndCentroid.gmt
// module id = 1022
// module chunks = 0